var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18next from "i18next";
import get from "lodash/get";
import merge from "lodash/merge";
import { ADMIN_SETTINGS_KEY, getAdminSettings, getParticipantsAsSelectOptions, getParticipantTitle, isParticipantValid, isValidationDisabled } from "../../../components/BookingForm/booking-form.helpers";
import { BILLER_META, STEP_META, INLINE_FIELDS } from "../../../classConstants";
import { normalizeField } from "../../../components/BookingFormPage/field-meta";
import { componentTypes } from "../../../components/Form/form-constants";
import { BookModel } from "../BookModel";
import { getClassName } from "../../../helpers";
var FormGroupModel = /** @class */ (function (_super) {
    __extends(FormGroupModel, _super);
    function FormGroupModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFormGroup = true;
        return _this;
    }
    FormGroupModel.prototype.getItemName = function () {
        return this.get("name");
    };
    FormGroupModel.prototype.getRelationName = function () {
        var _a;
        var formItem = this.formItems().first();
        var itemName = ((_a = formItem === null || formItem === void 0 ? void 0 : formItem.formField()) === null || _a === void 0 ? void 0 : _a.get("table_name")) || null;
        return itemName ? "form_data." + formItem.get("item_type_name") + "." + itemName : "";
    };
    FormGroupModel.prototype.formItems = function () {
        return this.hasMany("form_items", "formItems");
    };
    FormGroupModel.prototype.getStepData = function (props) {
        return {
            title: get(props, "title", this.get("title")),
            description: get(props, "description", this.get("presented.body")),
            component: get(props, "component", componentTypes.FIELD_SET),
            fields: props.fields,
            name: props.name || this.getItemName(),
            className: get(props, "className")
        };
    };
    FormGroupModel.prototype.getWaitingListForm = function (form, validationErrors, options) {
        var bookers_count = 1;
        var prefix = "form_data";
        // personal data index is derived from FormState.
        var participantIndex = 0;
        var participantValidIndex = isNaN(participantIndex) ? bookers_count : participantIndex;
        var fields = this.formItems().getFields(form, validationErrors, prefix, participantValidIndex);
        return this.getStepData({ fields: fields, name: this.getRelationName(), component: componentTypes.FIELD_SET });
    };
    FormGroupModel.prototype.getAsParticipantGroup = function (form, validationErrors, options) {
        var _this = this;
        var timespanId = get(options, "timespanId");
        var priceId = get(options, "priceId");
        var cartItem = form.rootCartItems.find(function (cartItem) { return cartItem.isRoot && Number(cartItem.priceId) === Number(priceId) && Number(cartItem.timespanId) === Number(timespanId); });
        var bookers_count = (Number(get(options, "shouldCollectParticipantInformation", true)) ? cartItem === null || cartItem === void 0 ? void 0 : cartItem.participantCount : 1) || 1;
        var prefix = "form_data";
        var participantKey = this.getRelationName();
        var validationDisabled = isValidationDisabled(form);
        var salutations = get(options, "salutations", {});
        var hasSavedParticipantData = form.hasParticipantData();
        var fields = new Array(bookers_count).fill(null).map(function (x, index) {
            var _a, _b, _c;
            var isBillRecipient = options.hideBillRecipeintStep && index === 0;
            // personal data index is derived from FormState.
            var participantIndex = Number((_b = (_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.personalDataIndex) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : index);
            var participantValidIndex = isNaN(participantIndex) ? index : participantIndex;
            var groupNameWithIndex = _this.formItems().first().getItemName(prefix, participantValidIndex);
            var formDataKey = _this.formItems().first().getItemName(prefix, participantValidIndex);
            var formValues = isNaN(participantIndex) ? {} : get(options.form || form, formDataKey, {});
            var participantData = merge({ title: "", first_name: "", last_name: "", index: index + 1, salutation: (_c = salutations[formValues === null || formValues === void 0 ? void 0 : formValues.salutation_id]) === null || _c === void 0 ? void 0 : _c.label }, formValues);
            var defaultTranslationKey = isBillRecipient ? "bookcart.biller_participant_header" : "bookcart.participant_header";
            var translationKeyWithValues = isBillRecipient ? "bookcart.biller_participant_name" : "bookcart.participant_name";
            var participantLabelKey = (isParticipantValid(participantData) ? translationKeyWithValues : defaultTranslationKey);
            var title = bookers_count <= 1 && !isBillRecipient ? "" : getParticipantTitle(participantLabelKey, participantData);
            var fields = hasSavedParticipantData || !isBillRecipient ? _this.formItems().getFields(form, validationErrors, prefix, participantValidIndex) : _this.getAsBillRecipientGroup(form, validationErrors, [], { timespanId: timespanId }).fields;
            var isValid = !validationDisabled && _this.options.collapseValidParticipantsByDefault ? fields.every(function (_a) {
                var name = _a.name, required = _a.required;
                return !required || !!get(form, name);
            }) : null;
            return {
                name: groupNameWithIndex,
                title: title,
                index: index + 1,
                fields: fields,
                defaultCollapsed: isValid
            };
        });
        return this.getStepData({ fields: fields, name: participantKey, component: componentTypes.FIELD_SET });
    };
    FormGroupModel.prototype.getAsBillRecipientGroup = function (form, validationErrors, participants, options) {
        var _a;
        if (participants === void 0) { participants = []; }
        if (options === void 0) { options = {}; }
        var timespanId = options.timespanId;
        var rootCartItem = form.rootCartItems.find(function (cartItem) { return cartItem.timespanId === timespanId; });
        var showCheckbox = options.shouldCollectParticipantInformation && !form.hasFixedBillRecipient && !options.hidePersonalData;
        var hideBillRecipeintStep = options.hideBillRecipeintStep;
        var forceNewRecipient = !!options.forceSeparateBillRecipient;
        var showDropdown = showCheckbox && (!forceNewRecipient || participants.length > 1);
        var bookersCount = hideBillRecipeintStep ? 0 : ((rootCartItem === null || rootCartItem === void 0 ? void 0 : rootCartItem.participantCount) || 1);
        var groupName = this.getItemName();
        var billReceiverIndex = "" + (form.billRecipientIndex || bookersCount);
        var fields = [];
        var salutations = get(options, "salutations", {});
        if (showCheckbox) {
            var translationLabel = form.hasSeparateBillRecipient ? "add_separate_bill_recipient_help_text_checked" : "add_separate_bill_recipient_help_text_unchecked";
            fields.push(normalizeField({
                field_type_name: "checkbox",
                checked: forceNewRecipient,
                title: i18next.t("bookcart.add_separate_bill_recipient"),
                children: i18next.t("bookcart." + translationLabel),
                name: "booking_data.has_separate_bill_data",
            }, {
                className: getClassName(STEP_META, BILLER_META),
            }));
        }
        if (options.shouldCollectParticipantInformation && !form.hasFixedBillRecipient) {
            var options_1 = !showDropdown ? [billReceiverIndex] : getParticipantsAsSelectOptions(participants, bookersCount, { salutations: salutations, selection: participants[billReceiverIndex] });
            fields.push(normalizeField({
                field_type_name: "select",
                placeholder: i18next.t("bookcart.select_bill_recipient"),
                name: "booking_data.bill_receiver_index",
                is_required: forceNewRecipient,
                title: i18next.t("bookcart.bill_recipient"),
                children: i18next.t("bookcart.bill_recipient_help_text"),
            }, {
                showDefaultOption: false,
                className: getClassName(STEP_META, BILLER_META),
                isHidden: !showDropdown || options_1.length <= 1,
                hidden: !showDropdown || options_1.length <= 1,
                allowBlank: false,
                disabled: options_1.length === 1,
                options: options_1,
            }));
        }
        var billerStepForm = isValidationDisabled(form) ? merge((_a = {}, _a[ADMIN_SETTINGS_KEY] = __assign({}, (getAdminSettings(form) || {})), _a), form) : form;
        fields.push({
            "name": "bill-recipient",
            component: componentTypes.BASIC,
            as: "div",
            className: get(this.options, "isAdminIntegration", false) ? INLINE_FIELDS : "",
            fields: this.formItems().getFields(billerStepForm, validationErrors, "form_data", Number(billReceiverIndex || bookersCount))
        });
        return this.getStepData({
            fields: fields.filter(Boolean),
            name: groupName
        });
    };
    FormGroupModel.prototype.getFormGroup = function (form, validationErrors, component) {
        var formGroupName = this.getItemName();
        var allFields = this.formItems().getFields(form, validationErrors, "form_data", 0, component);
        return this.getStepData({
            fields: allFields,
            name: formGroupName,
            component: component
        });
    };
    FormGroupModel.prototype.getFieldPaths = function () {
        return this.formItems().all().map(function (item) { return item.getFieldPaths(); }).flat();
    };
    return FormGroupModel;
}(BookModel));
export { FormGroupModel };
